module.exports = __webpack_public_path__ + "img/white_icon_outlined.9576cfa8.svg";